import React, { useEffect, useState, useContext } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import profile2 from "../../../images/profile/pic1.jpg";
import { ThemeContext } from "../../../context/ThemeContext";

const Header = () => {

  const { background, changeBackground } = useContext(ThemeContext);
  const [user, setUser] = useState(null);
  const nav = useNavigate();

  // ================= GET USER =================
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // ================= LOGOUT =================
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    nav("/page-login");
  };

  // ================= PAGE TITLE =================
  let path = window.location.pathname.split("/");
  let name = path[path.length - 1].split("-");
  let finalName = name.join(" ");

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">

            <div className="header-left">
              <div className="dashboard_bar" style={{ textTransform: "capitalize" }}>
                {finalName || "Dashboard"}
              </div>
            </div>

            <ul className="navbar-nav header-right">

              {/* ================= PROFILE ================= */}
              <Dropdown as="li" className="nav-item dropdown header-profile">

                <Dropdown.Toggle
                  as={Link}
                  variant=""
                  className="nav-link i-false"
                  to="#"
                >
                  <div className="header-info">
  <span>
    {user?.email || "Admin"}
  </span>
  {/* <small>ADMIN</small> */}
</div>
                  {/* <img src={profile2} width={20} alt="" /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu align="end" className="dropdown-menu dropdown-menu-right">

                  {/* <Link to="/app-profile" className="dropdown-item ai-icon">
                    <span className="ms-2">Profile</span>
                  </Link> */}

                  {/* ================= LOGOUT ================= */}
                  <button
                    onClick={handleLogout}
                    className="dropdown-item ai-icon text-danger"
                  >
                    Logout
                  </button>

                </Dropdown.Menu>

              </Dropdown>

            </ul>

          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;